import React from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SDeleteDevice } from '../../../apis/app.service';

import AppButton from '../../sharedcomponents/Buttons/AppButton/AppButton';
import { useDevicesPage } from '../../../store/DevicesProvider';

export default function ConfirmDeviceDelete() {
  const { device } = useDevicesPage();
  const { data } = device;

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: SDeleteDevice,
    onSuccess: ({ message }) => {
      queryClient.invalidateQueries({
        queryKey: ['devices'],
      });
      toast.success(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
    onError(error: Error) {
      const { message } = error;
      toast.error(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
  });

  const handleDelete = (deviceId: string) => {
    mutation.mutate(deviceId);
  };

  return (
    <>
      <div
        className="modal fade"
        id="kt_modal_confirm_delete"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Confirm Action</h2>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              Are you sure you want to delete device with ID{' '}
              <strong>{`${data.device_id}`}.</strong>
            </div>
            <div className="modal-footer">
              <AppButton
                btnType="danger"
                onClick={() => handleDelete(data.id!)}
                data-bs-dismiss="modal"
              >
                {!mutation.isPending && (
                  <span className="indicator-label">Delete</span>
                )}
                {mutation.isPending && (
                  <span
                    className="indicator-progress"
                    style={{ display: 'block' }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
